
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'
export default defineComponent({
  props: {
    meetingName: String
  },
  setup() {
    const router: Router = useRouter()
    const route: RouteLocationNormalizedLoaded = useRoute()
    const handelGoHome = () => {
      if (route.name !== 'home') {
        router.go(-1)
      }
    }
    return {
      handelGoHome
    }
  }
})
